export enum EApiUrl {
    unitySignIn = 'go-rewards-client-service/api/unanimity/signin',
    unitySignUp = 'go-rewards-client-service/api/unanimity/signup',
    unityOtp = 'go-rewards-client-service/api/unanimity/otp',
    unityUserSummary = 'go-rewards-client-service/api/unanimity/summary',
    unityDocuments = 'go-rewards-client-service/api/unanimity/consent-document',
    requestSmsCode = 'go-webshop/api/v1/auth/request-sms-code',
    verifySmsCode = 'go-webshop/api/v1/auth/verify-sms-code',
    profile = 'go-webshop/api/v1/profile',
    userBalance = 'go-webshop/api/v1/profile/balance',
    wdollarPackages = 'go-webshop/api/v1/shop/offers',
    publicWdollarPackages = 'go-webshop/api/v1/public/shop/offers',
    createPaysafeOrder = 'go-webshop/api/v1/shop/create-order',
    completePaysafeOrder = 'go-webshop/api/v1/shop/complete-order',
    redeemOptions = 'go-webshop/api/v1/freeplay/redemption-options',
    redeem = 'go-webshop/api/v1/freeplay/redeem',
    purchaseHistory = 'go-webshop/api/v1/profile/history',
    creditCard = 'go-webshop/api/v1/shop/saved-cards',
    creditCardDelete = 'go-webshop/api/v1/shop/delete-saved-card',
    createCustomerToken = 'go-webshop/api/v1/shop/create-single-use-customer-token',
    order = 'go-wdollar-portal/api/orders',
}
